import { GridColDef } from '@mui/x-data-grid-pro';
import { PhoenixGrid } from '@shared/components/grid/PhoenixGrid';

interface IOutOfSyncProps {
	gridData: { id: string }[];
	config: GridColDef[];
	title?: string;
}

const OutOfSyncGrid = ({ gridData, config, title }: IOutOfSyncProps) => {
	return (
		<PhoenixGrid
			autoHeight
			withHeader
			canNotCopy
			noButton
			name={title}
			columns={config}
			rows={gridData || []}
		/>
	);
};

export default OutOfSyncGrid;
